// extracted by mini-css-extract-plugin
export var text = "_7d-0";